import { z } from 'zod';

export const MAX_LIMIT = 100;
export const DEFAULT_LIMIT = 50;

export const PagingSchema = z.object({
  // we need to coerce to number because the query params are strings in NestJS
  limit: z.coerce.number().int().min(1).max(MAX_LIMIT).default(DEFAULT_LIMIT),
  offset: z.coerce.number().int().min(0).default(0).optional(),
});
export type Paging = z.infer<typeof PagingSchema>;

export const PaginatedSchema = <T>(schema: z.ZodType<T>) => {
  return z.object({
    data: z.array(schema),
    total: z.number(),
    offset: z.number(),
    limit: z.number(),
  });
};

export type Paginated<T> = {
  data: T[];
  total: number;
  offset: number;
  limit: number;
};

export function isPaginated<T>(
  data: Record<string, unknown>,
): data is Paginated<T> {
  return 'total' in data && 'offset' in data && 'limit' in data;
}
